import { Injectable } from '@angular/core';
import { gsap } from 'gsap';

@Injectable({ providedIn: 'root' })
export class AnimationsService {
  private shineTweens = new WeakMap<HTMLElement, gsap.core.Tween>();

  runIntroAnimation(logoEl: HTMLElement, wrapperEl: HTMLElement, shineEl?: HTMLElement): void {
    if (!logoEl || !wrapperEl) return;

    gsap.set(wrapperEl, { perspective: 800 });
    gsap.set(logoEl, { transformOrigin: '50% 50%' });

    const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
    tl.from(logoEl, { opacity: 0, scale: 0.8, rotateY: 90, duration: 0.8 })
      .to(logoEl, { filter: 'drop-shadow(0 0 16px #FFD400)', duration: 0.5 }, '-=0.2')
      .to(logoEl, { scale: 1.02, duration: 0.25 })
      .to(logoEl, { scale: 1, duration: 0.25 });

    if (shineEl) {
      gsap.set(shineEl, { x: '-120%', opacity: 0.0, skewX: -20 });
      tl.to(shineEl, { x: '300%', opacity: 0.65, duration: 0.8, ease: 'power2.out' }, '-=0.3')
        .to(shineEl, { opacity: 0, duration: 0.2 });
    }
  }

  runShineOnce(shineEl?: HTMLElement): void {
    if (!shineEl) return;
    const existing = this.shineTweens.get(shineEl);
    if (existing && existing.isActive()) return;

    const tween = gsap.fromTo(shineEl, { x: '-120%', opacity: 0.4 }, {
      x: '300%',
      opacity: 0.7,
      duration: 0.8,
      ease: 'power2.out',
      overwrite: false,
      onComplete: () => {
        this.shineTweens.delete(shineEl);
        gsap.set(shineEl, { opacity: 0 });
      }
    });
    this.shineTweens.set(shineEl, tween);
  }

  hoverEnter(logoEl?: HTMLElement): void {
    if (!logoEl) return;
    gsap.to(logoEl, { scale: 1.08, y: -2, filter: 'drop-shadow(0 0 20px #FFD400)', duration: 0.25, ease: 'power2.out' });
  }

  hoverLeave(logoEl?: HTMLElement): void {
    if (!logoEl) return;
    gsap.to(logoEl, { scale: 1, y: 0, filter: 'drop-shadow(0 0 0 rgba(0,0,0,0))', duration: 0.3, ease: 'power2.out' });
  }

  animateOnScroll(logoEl?: HTMLElement, scrolled?: boolean): void {
    if (!logoEl) return;
    gsap.to(logoEl, { y: scrolled ? -4 : 0, duration: 0.3, ease: 'power1.out' });
  }
}